import { Component, ChangeDetectionStrategy, Input, OnInit, HostListener, Output, EventEmitter } from '@angular/core';
import { ConfigurationKey } from 'src/app/core/models/configuration-key';
import { InstanceService } from '@commonspirit/ngx-instance';
import { EnvironmentService } from '@commonspirit/ngx-environment';
import { FacetSummary, FiltersModel } from 'src/app/shared/models/filters';
import * as fromFalLite from '../../../fal-lite/+state';
import { Store } from '@ngrx/store';
import { FALLiteSelectedFilters } from 'src/app/shared/models/v2/search';

@Component({
  selector: 'fal-lite-filters-container',
  templateUrl: './fal-lite-filters-container.component.html',
  styleUrls: ['./fal-lite-filters-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FalLiteFiltersContainerComponent implements OnInit {
  @Input() keyword = '';
  @Input() filtersModel: FiltersModel = new FiltersModel(this.service);
  @Input() falBaseUrl = '';
  @Input() geoSearchTerm = '';
  @Input() showLandingFilters = true;
  @Input() isLocationSelected = false;
  searchRadiusFilterDisplayText = '';
  showSearchRadiusFilter = false;
  defaultSearchDistance: number | undefined = 0;
  searchDistance = 0;
  showServicesAvailableFilter = false;
  servicesAvailableFilterDisplayText = '';
  showLocationTypeFilter = false;
  locationTypeFilterDisplayText = '';
  filtersKey = ConfigurationKey.Filters;
  searchRadiusKey = ConfigurationKey.SearchRadiusFilter;
  selectedLocations: string | undefined = '';
  selectedSpecialties: string | undefined = '';
  fALLiteSelectedFilters: FALLiteSelectedFilters = {
    searchDistance: 0,
    selectedLocations: '',
    selectedSpecialties: ''
  };

  ngOnInit(): void {
    this.setFilters();
  }

  constructor(public service: InstanceService, public environmentService: EnvironmentService, public store: Store) {}

  async handleFilterChange(event: any): Promise<void> {
    if (event.selectedSpecialties.length > 0 && event.servicesAvailableApplied) {
      this.selectedSpecialties = event.selectedSpecialties.map((x: FacetSummary) => x.name).join('|');
      this.servicesAvailableFilterDisplayText =
        event.selectedSpecialties.length > 1 ? `${event.selectedSpecialties.length} Services Available` : event.selectedSpecialties[0].name;
    } else {
      this.servicesAvailableFilterDisplayText = this.filtersModel.servicesAvailableFilterDisplayText;
    }
    if (event.selectedLocationTypes.length > 0 && event.locationTypeApplied) {
      this.selectedLocations = event.selectedLocationTypes.map((x: FacetSummary) => x.name).join('|');
      this.locationTypeFilterDisplayText =
        event.selectedLocationTypes.length > 1
          ? `${event.selectedLocationTypes.length} Location types`
          : event.selectedLocationTypes[0].name;
    } else {
      this.locationTypeFilterDisplayText = this.filtersModel.locationTypeFilterDisplayText;
    }

    if (event.locationSearchRadius !== this.defaultSearchDistance) {
      this.searchDistance = event.locationSearchRadius;
      this.searchRadiusFilterDisplayText =
        event.locationSearchRadius == 1 ? `${event.locationSearchRadius} Mile` : `${event.locationSearchRadius} Miles`;
    } else {
      this.searchRadiusFilterDisplayText = `${this.defaultSearchDistance} Miles`;
      this.searchDistance = event.locationSearchRadius;
    }
    this.updateSelectedFilters();
  }

  setFilters(): void {
    const filters =
      (this.service.getConfiguration(this.filtersKey)?.value as {
        displayText?: string;
        enabled: boolean;
        defaultDistance?: number;
      }[]) ?? (undefined as unknown);
    if (filters) {
      for (const filter of filters) {
        switch (filter?.displayText?.toLowerCase()) {
          case 'search radius': {
            this.searchRadiusFilterDisplayText = `${filter.defaultDistance} Miles`;
            this.showSearchRadiusFilter = filter.enabled;
            this.defaultSearchDistance = filter.defaultDistance;
            break;
          }
          case 'location type': {
            const locationTypes =
              (this.service.getConfiguration(ConfigurationKey.LocationTypes)?.value as { item?: [{ value: string, label: string }] }) ??
              (undefined as unknown);
            this.locationTypeFilterDisplayText = filter.displayText;
            this.showLocationTypeFilter = filter.enabled;
            this.filtersModel.availableLocationTypes = [];
            locationTypes.item?.forEach((x) => {
              this.filtersModel.availableLocationTypes.push({
                name: x.value,
                selected: false,
                label: x.label
              });
            });
            break;
          }
          case 'services available': {
            const specialties =
              (this.service.getConfiguration(ConfigurationKey.Specialities)?.value as { item?: [{ value: string; label: string }] }) ??
              (undefined as unknown);
            this.servicesAvailableFilterDisplayText = filter.displayText;
            this.showServicesAvailableFilter = filter.enabled;
            this.filtersModel.availableSpecialties = [];
            specialties.item?.forEach((x) => {
              this.filtersModel.availableSpecialties.push({
                name: x.value,
                selected: false,
                label: x.label
              });
            });
            break;
          }
          default:
            break;
        }
      }
    }
  }
  updateSelectedFilters(): void {
    this.fALLiteSelectedFilters = {
      searchDistance: 0,
      selectedLocations: '',
      selectedSpecialties: ''
    };
    this.fALLiteSelectedFilters.selectedSpecialties = this.selectedSpecialties;
    this.fALLiteSelectedFilters.selectedLocations = this.selectedLocations;
    this.fALLiteSelectedFilters.searchDistance = this.searchDistance;
    this.store.dispatch(fromFalLite.FalLiteActions.setFalLiteSelectedFilters({ selectedFilters: this.fALLiteSelectedFilters }));
  }
}
